import React, { Fragment, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ImportComponent } from '../constants/ComponentImport';
import { useDispatch } from 'react-redux';
import { PAGE_TITLE_REDUCERS } from '../store/orgSlice';

interface RouteData {
  component?: string;
  link: string;
  title?: string;
}

interface SubSubMenuData extends RouteData {
  sub_sub_m_id: number;
  name: string;
  name_nep?: string;
  des?: string;
  priority: number;
  showmenu: boolean;
  sidedrawer: boolean;
  updated_at: string;
  created_at: string;
  sub_m_id: number;
}

interface SubMenuData {
  sub_m_id: number;
  subsubmenus?: SubSubMenuData[];
  name: string;
  name_nep?: string;
  short_name: string;
  updated_at: string;
  created_at: string;
  menu_id: number;
}

interface MenuData {
  menu_id: number;
  submenus?: SubMenuData[];
  name: string;
  name_nep?: string;
  icon?: string;
  short_name: string;
  priority: number;
  updated_at: string;
  created_at: string;
}

interface AppRoutesProps {
  data: MenuData[] |null;
  setIconsButton: (iconState: string) => void; 
}

const AppRoutes: React.FC<AppRoutesProps> = ({ data=[], setIconsButton }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  
useEffect(() => {
  let foundRoute: RouteData | undefined;

  // Iterate through your menu and submenus
  for (const menu of data ||[]) {
    if (menu.submenus) {
      for (const submenu of menu.submenus) {
        if (submenu.subsubmenus) {
          // Make sure `route` is the parameter of the find function
          foundRoute = submenu?.subsubmenus?.find((route:RouteData) => {
            // Strip the dynamic part (id) from the route and the pathname for comparison
            const routeBase = route?.link?.replace(/\/\d+$/, '/:id'); // Replace last number with ':id'
            const pathBase = location.pathname.replace(/\/\d+$/, '/:id'); // Replace last number with ':id'
            return routeBase === pathBase;
          });
          if (foundRoute) break;
        }
      }
      if (foundRoute) break;
    }
  }

  // Dispatch and update page title if a route is found
  if (foundRoute?.title) {
    dispatch(PAGE_TITLE_REDUCERS({ title: foundRoute.title }));
    document.title = 'Nexapp - ' + foundRoute.title;
  }
}, [location, data, dispatch]);
  
  
  return (
    <Fragment>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {Array.isArray(data) &&
            data.map((menu, menuIndex) =>
              Array.isArray(menu?.submenus) &&
              menu.submenus.map((submenu, subMenuIndex) =>
                Array.isArray(submenu?.subsubmenus) &&
                submenu.subsubmenus.map((route, routeIndex) => {
                  const ComponentData = route?.component
                    ? ImportComponent({ route: route.component })
                    : null;
                  return (
                    <Route
                      key={`${menuIndex}-${subMenuIndex}-${routeIndex}`}
                      path={route?.link}
                      element={
                        ComponentData ? (
                          <Suspense fallback={<div>Loading...</div>}>
                            {React.cloneElement(ComponentData, {
                              setIconsButton: setIconsButton,
                              PageTitle: route?.title,
                            })}
                          </Suspense>
                        ) : null
                      }
                    />
                  );
                })
              )
            )}
          {/* <Route path="*" element={<div>404 Not Found</div>} /> */}
        </Routes>
      </Suspense>
    </Fragment>
  );
};

export default AppRoutes;
